import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import firebase from "firebase/app";
import 'firebase/firestore';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import { red } from '@material-ui/core/colors';
import CreateIcon from '@material-ui/icons/Create';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import DriveEtaIcon from '@material-ui/icons/DriveEta';
import SaveIcon from '@material-ui/icons/Save';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';



const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(2),
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
  avatar: {
    backgroundColor: red[500],
  },
}));



     
     
     var listacatmotora=[];
   
    var novo; 
export default function RecipeReviewCard(props) {
  const [itemtipoveiculo, setitemtipoveiculo] = React.useState([]);
  const [tipoveiculo,setatipoveiculo]=React.useState('');
  const [vkmrodado,setavkmrodado]=React.useState('');
  const [catmotora,setacatmotora]=React.useState([]);
  const [stid,setastid]=React.useState('');
 

  React.useEffect(()=>{
    setitemtipoveiculo(props.props);
    firebase.firestore().collection("categoriasmotorista")
    .get()
    .then(function(querySnapshot) {
       listacatmotora=[];
        querySnapshot.forEach(function(doc) {
         
          listacatmotora.push({value: doc.id, label: doc.data().catmotorista});
            
        });
        setacatmotora(listacatmotora);
    })
    .catch(function(error) {
        console.log("Erro ao carregar (categorias motorista): ", error);
    });
    
    /*
      console.log("valor id " + stid)*/
     

  },[0])

  React.useEffect(()=>{

    


    
    setaitem();
    
    async function setaitem(){
      
      console.log("valor tipo de veiculo", props.props)
      var tipoveiculo;
      itemtipoveiculo.forEach(item=>{tipoveiculo=item.tipoveiculo});
      setatipoveiculo(tipoveiculo);
      var kmr;
      itemtipoveiculo.forEach(item=>{kmr=item.valorkmrodado});
      setavkmrodado(kmr);
      var listcats;
      itemtipoveiculo.forEach(item=>{listcats=item.categoriasmotorista});
      setlistacatmotorista([listcats]);
      console.log("valor do pros catmotorista", itemtipoveiculo);
      itemtipoveiculo.forEach(modelo=>(novo=modelo.novo));
      var sid;
      itemtipoveiculo.forEach(item=>{sid=item.id});
      setastid(sid);
      console.log("valor do id ", sid);
    }
   
  if (novo) {
    handleeditar();
  } 

  

  } , [itemtipoveiculo])
//*******************************salvar edit************ */

const handlesalvar=()=>{
  
  var tipov = tipoveiculo;
  var valorkmrodado = vkmrodado;
  var catm = listacatmotorista[0];
  var userid=stid;
 
    if(novo){
      var db = firebase.firestore();
    var docRef = db.collection("tiposveiculo").doc();
    console.log('docref id ',docRef.id);
    var dcid = docRef.id;
    docRef.set({ tipoveiculo: tipov,
                  valorkmrodado: valorkmrodado, categoriasmotorista: catm                  
                }).then(function () {
                  setedita(true);
                  setbotaoedit(false);
                  setExpanded(false);

                  setastid(dcid);
                  novo=false;

                 
              }).catch(function (error) {
                    var errorMessage = error.message;
          
                  alert(errorMessage);
                  })
    }else{
      console.log("valo do id", userid);
      console.log("valo do id", tipoveiculo);
      console.log("valo do id", valorkmrodado);
      console.log("valo do id", listacatmotorista);
      var user = firebase.firestore().collection("tiposveiculo").doc(userid);
    
        user.update({tipoveiculo: tipoveiculo,
        valorkmrodado: valorkmrodado, categoriasmotorista: catm})
      .then(() => {
          console.log("Document successfully updated!");
          setedita(true);
                setbotaoedit(false);
                setExpanded(false);
                
      })
      .catch((error) => {
          // The document probably doesn't exist.
          console.error("Error updating document: ", error);
      });
      }       
    }
  //**************************controle habilita e desabilita */

  const [edita, setedita] = React.useState(true);
  const [botaoedit, setbotaoedit] = React.useState(false);

  const handleeditar=()=>{
    setedita(false);
    setbotaoedit(true);
    setExpanded(true);
  }

  const handleClickAway = () => {
    setExpanded(false);
    setedita(true);
    setbotaoedit(false)
  };
 //********************************** */

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
     
       const handleExpandClick = () => {
         setExpanded(!expanded);
         if(expanded){
         setedita(true);
         setbotaoedit(false)}
         
       };
  //********************************controle autocomplete */
  const [listacatmotorista, setlistacatmotorista] = React.useState([]);
 
  
  
  const handleuniade=(event,value)=>(

    setlistacatmotorista([value])
)
  //*************************************** */
  return (
    <ClickAwayListener onClickAway={handleClickAway}>
    <Card className={classes.root} >
      
           <CardHeader
             avatar={
               
               <Avatar aria-label="Veículo" className={classes.avatar}>
                <DriveEtaIcon />
               </Avatar>
             }
            
             title={tipoveiculo}
             
           />
           
           <CardContent id="prop">

           
           <Typography variant="body2" color="textSecondary" component="p">
              Quilômetro Rodado: R$ {vkmrodado}
             </Typography>

             <Typography variant="body2" color="textSecondary" component="p">
               {itemtipoveiculo.map(modelo=>(modelo.categoriamotorista))}
             </Typography>
             

           </CardContent>
                    
            <CardActions disableSpacing>
           
              
             <IconButton id="btsalvar" aria-label="Salvar" disabled={edita} onClick={handlesalvar}>
               <SaveIcon />
             </IconButton>
             <IconButton id="bteditar" aria-label="Editar" disabled={botaoedit} onClick={handleeditar}>
               <CreateIcon />
             </IconButton>
               
             <IconButton
                    className={clsx(classes.expand, {
                      [classes.expandOpen]: expanded,
                    })}
                    onClick={handleExpandClick}
                    aria-expanded={expanded}
                    aria-label="Visualizar"
                  >
                    <ExpandMoreIcon />
                  </IconButton>
          
                </CardActions>
                <Collapse in={expanded} timeout="auto" unmountOnExit>
                  <CardContent>

               <TextField
                 variant="outlined"
                 margin="normal"
                  onChange={ e=>setatipoveiculo(e.target.value)}
                 required
                // type=""
                 fullWidth
                 id="tipoveiculo"
                 label="Tipo de Veículo"
                 name="tipoveiculo"
                 defaultValue = {tipoveiculo}
                 disabled={edita}
                 />
        
               <TextField
                 variant="outlined"
                 margin="normal"
                 onChange={ e=>setavkmrodado(e.target.value)}
                 required
                 type=""
                 fullWidth
                 id="valorkmrodado"
                 label="Quilomêtro Rodado R$"
                 name="valorkm"
                 defaultValue=  {vkmrodado}
                    disabled={edita}
                    
               />
    
                <Autocomplete onChange={handleuniade}
                       // required
                        multiple
                        disabled={edita}
                        id="tags-outlined"
                        options={catmotora}                  
                       getOptionLabel={(option) => option.label}
                        value={listacatmotorista[0]} 
                      // getOptionSelected={(option,temp) => option.id==temp.id}
                       //getOptionSelected={(option,value) => option===value}
                        filterSelectedOptions
                        renderInput={(params) => (
                        <TextField
                            {...params}
                            
                            variant="outlined"
                            label="Categoria de Motoristas Habilitados"
                            placeholder="selecione uma categoria"
                        />
                        )}
                    />
        
                   
                 
                <Typography component="h7" variant="h10">
              * Preenchimento obrigatório 
             </Typography>
        
             
           
                                
           
          
                  </CardContent>
                  
                </Collapse>
               
         </Card>
         </ClickAwayListener>
  );
}

/*
 <form className={classes.form} onSubmit={handlesalvar} noValidate={false}>
                </form>
*/